import { Box } from "@chakra-ui/react"
import {
  EDITOR_MODE,
  scopeContentData,
  useEditorDispatch,
  useEditorMode
} from "@pathwright/blocks-engine"
import classnames from "classnames"
import { memo, useCallback } from "react"
import styled from "styled-components"
import BlockContainer from "../block/BlockContainer"

const BlockEditorContainer = ({ children }) => {
  return (
    <Box
      width="100%"
      position="relative"
      minHeight="30px"
      sx={{
        ".BlocksControls": {
          display: "none"
        }
      }}
      _hover={{
        ".BlocksControls": {
          display: "flex"
        }
      }}
    >
      {children}
    </Box>
  )
}

const BlockEditorComponentContainer = styled.div`
  flex-grow: 1;
  width: 100%;
`

const BlockEditorWrap = styled.div`
  position: relative;
`

const propsAreEqual = (prevProps, nextProps) => {
  if (nextProps.blockIndex !== prevProps.blockIndex) return false
  if (nextProps.blockType !== prevProps.blockType) return false
  if (nextProps.block !== prevProps.block) return false

  return true
}

const BlockEditor = memo((props) => {
  const { blockIndex, blockType, block } = props

  const { data, id, type, layout } = block

  const { mode } = useEditorMode()
  const { handleBlockChange: onChange } = useEditorDispatch()

  const handleChange = useCallback(
    (dataUpdates) => {
      const nextData = scopeContentData({ ...data, ...dataUpdates }, blockType)
      onChange(nextData, id)
    },
    [block, blockType, onChange]
  )

  const className = classnames(
    "ContentBlock",
    `ContentBlockType-${type}`,
    `ContentBlockLayout-${layout}`
  )

  if (mode === EDITOR_MODE.VIEW)
    return (
      <div className={className}>
        <BlockContainer
          key={`${block.contentID}:${block.id}`}
          onChange={handleChange}
          block={block}
        />
      </div>
    )

  return (
    <BlockEditorWrap className={className}>
      <BlockEditorContainer>
        <BlockEditorComponentContainer>
          <BlockContainer
            key={`${block.contentID}:${block.id}`}
            onChange={handleChange}
            blockIndex={blockIndex}
            block={block}
          />
        </BlockEditorComponentContainer>
      </BlockEditorContainer>
    </BlockEditorWrap>
  )
}, propsAreEqual)

export default BlockEditor
